module.exports = __webpack_public_path__ + "static/media/pick_task.f8db4044.svg";